import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PhotoCategoryApi } from 'api';

export function useCreatePhotoCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['create-photo-category'],
    mutationFn: async (data) => {
      return PhotoCategoryApi.create(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['photo-categories']);
    },
  });
}
